export const en = {
  msg:
    {
      'username': 'Username',
      'password': 'Password',
      'login': 'Login',
      'username_not_found': 'Please enter your Username',
      'password_not_found': 'Please enter your Password',
      'error': 'Invalid username or password',
      'changeLanguage': '',
      'lang-en': 'English',
      'lang-ms': 'Bahasa Melayu',
      'submit_button_text': 'Submit',
      'enter': 'Enter',
      'en': 'English',
      'ms': 'Bahasa Melayu',
      'zh': 'Chinese',
      'ta': 'Tamil',
      'km': 'Khmer',
      'th': 'Thai',
      'id': 'Bahasa Indonesia',
      'ar': 'Arabic',
      'blank_username_field': 'Please enter your username.',
      'blank_password_field': 'Please enter your password.',
      'invalid_credentials': 'Invalid username or password.',
      'copyright': 'Powered by Global Psytech',
      system_requirements: 'System Requirements',
      requirements: 'requirements',
      supported: 'supported',
      system_requirements_header_text: 'This table outlines the requirements for using the NeDAS system. In some cases, NeDAS will still work on older versions of browsers; however, these are not officially supported.',
      web_browser: 'Web browser',
      google_chrome: 'Google Chrome',
      mozilla_firefox: 'Mozilla Firefox',
      apple_safari: 'Apple Safari',
      microsoft_edge: 'Microsoft Edge',
      javascript: 'JavaScript',
      cookies: 'Cookies',
      screen_resolution: 'Screen resolution',
      supported_latest_version: 'Latest version of Google Chrome, Mozilla Firefox, Apple Safari or Microsoft Edge',
      supported_javascript: 'Must be enabled; automatically included with supported browsers',
      supported_cookies: 'Must be enabled; supported in the above browsers',
      supported_screen_resolution: '1024 × 768+',
      troubleshooting: 'Troubleshooting',
      troubleshooting_header_text: 'If you are experiencing issues with test delivery, please check the following:',
      troubleshooting_body_point_1_text: 'Verify that you are using a supported browser according to our system requirements.',
      troubleshooting_body_point_2_text: 'Clear your browser’s cache.',
      troubleshooting_body_point_2_child_1_text: 'If you are using a Windows computer use the keyboard command Ctrl + Shift + Del to access the browsing history menu.',
      troubleshooting_body_point_2_child_2_text: 'If you are using an Apple computer use the keyboard command ⌘ + Shift + Del to access the browsing history menu.',
      troubleshooting_body_point_3_text: 'Verify with your network administrator that you have a minimum internet speed of 1 Mbps per student.',
      troubleshooting_body_point_4_text: 'Verify with your network administrator that the internet domain assessment.nedasmy.com and its subdomains are allowed by your network’s security features (e.g., firewall, network and router settings, blacklist/whitelist). Please note that child-oriented security software like NannyNet and GoGuardian may cause testing failures as well.',
      troubleshooting_body_point_5_text: 'If you are still encountering issues with test delivery, contact support@globalpsytech.com',
      back_to_login: 'Back to login',
    }
}
